export default "__VITE_ASSET__Duzrm2rL__"